export default "__VITE_ASSET__De1uFTRU__"